export default __webpack_public_path__ + "static/media/Grace.99c9210c.png";